console.log("init Proteus treatments -- 1.03")

document.addEventListener("proteus:cart-changed", async (e) => {
  console.log("proteus: cart updated", e.detail);
  window.cart_data = e.detail;
});

//
// START support for PP Offers
//

// support for proteus pp_offers
window.pp_active = true;
if(window.location.href.indexOf("qa=pp") > -1 || window.pp_active){
  window.sessionStorage.setItem("Proteus PP QA", true);
}

const push_pp_offers = () => {
  if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

    // window.cart_pp_offers = [];
    if(window.location.href.indexOf("new_pp") > -1){
      window.cart_pp_offers = window.cart_pp_offers_new
    }

    let session_id = window.sessionStorage.getItem("Proteus pp-session-id");
    fetch("https://proteus-rawsugarliving.fly.dev/api/pp_offers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        referenceId: session_id,
        offers: window.cart_pp_offers
      })
    }).then(res => res.json()).then(console.log).catch(console.error);

  }
};

waitUntil(() => {
  return typeof window.cart_pp_offers != "undefined" && window.cart_pp_offers.length > 0;
}).then(() => {

  if(!window.sessionStorage.getItem("Proteus pp-session-id") && window.sessionStorage.getItem("Proteus PP QA")){
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}).catch();

/*
// TODO: this call intercept works fine, maybe just make it a little less bloated
(function() {
  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    if (typeof url === "string" && url.includes("/cart/")) {
      response.clone().json().then(cart => {
        document.dispatchEvent(
          new CustomEvent("proteus:cart-changed", { detail: cart })
        );
      }).catch(() => {});
    }

    return response;
  };
})();

document.addEventListener("proteus:cart-changed", (e) => {
  console.log("Cart updated", e.detail);
});
*/

document.addEventListener("proteus:cart-changed", (e) => {
  // console.log("proteus: cart updated", e.detail);
  window.cart_data = e.detail;

  // The fetch hook dispatches this event with ANY /cart/* response body — including
  // error payloads (422s have no `items`) and empty carts. Guard both: the offers API
  // 500s on an empty `ids=` param, and `items` may be missing entirely.
  let cart_items = (e.detail && Array.isArray(e.detail.items)) ? e.detail.items : [];
  cart_items.sort(function(a, b) {
    return b.price - a.price;
  });

  let offers_max = cart_items.length;
  if(cart_items.length > 3){
    offers_max = 3;
  }

  let cart_prod_ids = [];
  for(let i = 0; i < offers_max; i++){
    if (cart_items[i].product_id) cart_prod_ids.push(cart_items[i].product_id);
  }
  if (cart_prod_ids.length === 0) return;

  get_proteus_product_data(cart_prod_ids.toString()).then(response => {
    console.log("get_proteus_product_data", response)
    window.staged_pp_offers = response.offers || [];
    
    window.cart_pp_offers = [];
    for(let i = 0; i < window.staged_pp_offers.length; i++){

      let discount_amount = window.staged_pp_offers[i].changes[0].discount.value;
      let discount_type = window.staged_pp_offers[i].changes[0].discount.valueType;

      let content_compare_at = window.staged_pp_offers[i].content_compare_at;
      let content_offer_price = window.staged_pp_offers[i].content_offer_price;

      if(window.staged_pp_offers[i].content_products.length > 0){
        
        content_compare_at = parseFloat(window.staged_pp_offers[i].content_products[0].variants.edges[0].node.price).toFixed(2);
        if (discount_type === "percentage") {
          content_offer_price = parseFloat(
            (content_compare_at * (1 - discount_amount / 100)).toFixed(2)
          );
        } else {
          content_offer_price = parseFloat(
            (content_compare_at - discount_amount).toFixed(2)
          );
        }

      }

      window.cart_pp_offers.push({

        pp_offer_type: window.staged_pp_offers[i].def_type,
        pp_offer_new_qty: window.staged_pp_offers[i].def_quantity,
        pp_offer_new_interval: window.staged_pp_offers[i].ref_new_interval,
        pp_offer_id: window.staged_pp_offers[i].def_offer_id,
        pp_offer_banner_title: window.staged_pp_offers[i].content_banner_title,
        pp_offer_banner_subtitle: window.staged_pp_offers[i].content_banner_subtitle,
        pp_offer_title: window.staged_pp_offers[i].content_title,
        pp_offer_image_url: window.staged_pp_offers[i].content_images[0],
        pp_offer_description: [window.staged_pp_offers[i].content_description],
        pp_offer_compare_at: content_compare_at,
        pp_offer_price: content_offer_price,
        changes: window.staged_pp_offers[i].changes,

      });

    }

    push_pp_offers();

  }).catch((err) => {
    console.warn("proteus: offers unavailable", err);
  })
});

async function get_proteus_product_data(prod_ids) {
  console.log("get_proteus_product_data()");
  // could potentially do this via Shopify REST API
  const response = await fetch(`https://proteus-rawsugarliving.fly.dev/api/catalog?lookup=product_offers&ids=${prod_ids}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

//
// END support for PP Offers
//

// start [RAW-12]

const incentives_data = [
  {
    threshold: 3500,
    label: "get <span>free shipping</span>",
  }
];

const max_message = "get free shipping"

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

const update_cart = () => {
  
  let cart_total = cart_data.total_price
  /*
  let cart_total = 0
  for(let i = 0; i < window.cart_data.items.length; i++){
    if(window.cart_data.items[i].properties["_category"] == "apparel" || 
    window.cart_data.items[i].properties["_category"] == "tights" || 
    window.cart_data.items[i].properties["_bundler_id"]){
      cart_total = cart_total + parseInt(window.cart_data.items[i].quantity);
    }
  }
  */

  waitForElement('.js-progressive-incentive').then(incentive => {

    let incentives_html = ``;
    let message_html = ``;
    for(let i = 0; i < incentives_data.length; i++){
      let threshold_met = cart_total >= incentives_data[i].threshold ? true : false;
      let previous_threshold = i > 0 ? incentives_data[i - 1].threshold : 0;
      let threshold_progress = parseInt(((cart_total - previous_threshold) / (incentives_data[i].threshold - previous_threshold))*100);
      
      incentives_html += `
        <div class="js-progressive-incentive--threshold" data-threshold="${incentives_data[i].threshold}" data-met="${threshold_met}" data-progress="${Math.max(0, Math.min(100, threshold_progress))}">
          <div class="js-progressive-incentive--fill-container">
            <div class="js-progressive-incentive--fill" style="width: 0%;"></div>
          </div>
          <div class="js-progressive-incentive--label">${incentives_data[i].label.replace("get ", "")}</div>
        </div>
      `;
      if(message_html == "" && !!cart_total){

        let met_message = ``;
        if(i-1 >= 0){
          met_message = `You ${incentives_data[i-1].label}!`;
        }

        const needed = incentives_data[i].threshold - cart_total;
        const pairText = needed === 1 ? 'pair' : 'pairs';
        const countText = needed === 1 ? 'one more' : `${needed} more`;

        if (!threshold_met) {
          // message_html = `${met_message} Add ${countText} ${pairText} to ${incentives_data[i].label}`;
          message_html = `${met_message} Add $${(needed/100).toFixed(2)} to ${incentives_data[i].label}`;
        } else if (threshold_met && i === incentives_data.length - 1) {
          message_html = `You ${max_message}`;
        }

      }
    }

    incentive.querySelector('.js-progressive-incentive--message').innerHTML = message_html;
    incentive.querySelector('.js-progressive-incentive--bar').innerHTML = incentives_html;

    // could be delayed to give an animation
    setTimeout(() => {
      let thresholds = document.querySelectorAll('.js-progressive-incentive--threshold');
      for(let i = 0; i < thresholds.length; i++){
        let threshold_progress = thresholds[i].getAttribute("data-progress");
        thresholds[i].querySelector('.js-progressive-incentive--fill').style.width = `${threshold_progress}%`;
      }
    }, 10)

  }).catch();
   
}

observeSelector('.cart-drawer__top', fs_bar => {
  
  if(document.querySelectorAll('.js-progressive-incentive').length == 0){
    // document.querySelector('.cart-drawer__line-items').insertAdjacentHTML("beforebegin", `
    fs_bar.insertAdjacentHTML("afterend", `
      <style>
      .Drawer__Container{
        max-height: calc(100vh - 300px) !important;
      }
      .js-progressive-incentive{
        margin-top: -2rem;
        padding: 1rem 1rem 2.5rem 1rem;
        border-color: #666;
        border-bottom: 1px solid #ddd;
      }

      @media(max-width: 768px){
        .js-progressive-incentive{
          font-size: .85rem;
        } 
      }

      .js-progressive-incentive--message{
        text-align: center;
        padding: .25rem 0;
      }
      .js-progressive-incentive--message span{
        
      }
      .js-progressive-incentive--bar{
        display: flex;
        border: 1px solid;
        border-radius: 10px;
      }

      .js-progressive-incentive--threshold{
        padding: 3px;
        position: relative;
        border-left: 1px solid;
        width: 100%;
      }
        
      .js-progressive-incentive--threshold:first-child{
        border-left: 0;
      }

      .js-progressive-incentive--threshold:first-child .js-progressive-incentive--fill-container,
      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--fill-container{
        border-radius: 10px 0 0 10px;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--fill-container{
        border-radius: 0 10px 10px 0;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .js-progressive-incentive--fill{
        background: #473729;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        max-width: 100%;
        min-width: 0;
        width: 0;
      }
      .js-progressive-incentive--label{
        position: absolute; 
        right: -50%;
        bottom: -1.5rem;
        width: 100%;
        text-align: center;
        display: none;
      }

      @media(max-width: 768px){
        .js-progressive-incentive--label{
          font-size: .75rem;
        }
      }

      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--label{
        right: -.5rem;
        text-align: right;
      }

      .js-progressive-incentive--threshold:not([data-progress="100"], 
      [data-progress="0"]) .js-progressive-incentive--fill{
        /* transition: 1.5s ease; */
      }

      [data-progress="100"] .js-progressive-incentive--fill{
        width: 100% !important;
      }
      </style>
      <div class="js-progressive-incentive Cart__ShippingNotice Heading--bebas Text--center">
        <div class="js-progressive-incentive--message"></div>
        <div class="js-progressive-incentive--bar"></div>
      </div>
    `);
  }
 
  // init 
  update_cart();

  setTimeout(() => {
    update_cart(); 
  }, 2500);

});

let cached_item_count = cart_data.item_count;
setInterval(() => {
  
  if(cached_item_count !== cart_data.item_count){
    // console.log("compared, OOOOOOH changes");
    update_cart()
    cached_item_count = cart_data.item_count;
  } else {
    // console.log("compared, no changes");
  }
  
}, 1500)

// end [RAW-12]

// =============================================================================
// [RAW-15] Multi-Pack with Discount
//
// DEPENDENCIES from proteus-utils (must be loaded before this script):
//   - waitForElement(selector)   -> Promise that resolves when element exists
//
// -- Activation ---------------------------------------------------------------
// This script does NOT run automatically. It exposes a global function that must be
// called by an external script to activate the treatment.
//
// Usage from external script:
//   window.activateRAW15()
//
// -- Product scope --------------------------------------------------------------
// Pilot handles only (packOffersByCategory below). 
// Add more handles to a category's `handles` array as they're
// provided; unlisted handles are a no-op.
// =============================================================================

const RAW15_SETTINGS = {
  experimentId: "RAW-15",
  version: "v1",
  freeShippingOnPacks: true,

  packOffers: {
    2: {
      handles: [
        "deodorant-vanilla-bean-charcoal-2-7-oz",
        "deodorant-beach-rose-aloe-2-7-oz",
        "kids-2-in-1-bubble-bath-body-wash-12-oz-strawberry-vanilla",
        "kids-2-in-1-bubble-bath-body-wash-12-oz-super-berry-cherry",
        "deodorant-eucalyptus-fresh-mint-2-7-oz",
        "kids-2-in-1-bubble-bath-body-wash-12-oz-watermelon-lemonade",
        "kids-strong-shiny-leave-in-conditioning-cream-3-5-oz-strawberry-oat-milk",
        "kids-2-in-1-shampoo-conditioner-12-oz-strawberry-kiwi",
        "deodorant-santal-verbena-2-7-oz",
        "kids-2-in-1-shampoo-conditioner-12-oz-coconut-aloe-vera",
        "kids-2-in-1-shampoo-conditioner-12-oz-watermelon-apple",
        "kids-2-in-1-shampoo-conditioner-sensitive-fragrance-free-12-fl-oz",
        "kids-2-in-1-body-wash-bath-soak-sensitive-fragrance-free-12-fl-oz",
        "kids-detangler-6-oz-strawberry-oat-milk",
        "kids-detangler-6-oz-coconut-milk-banana",
        "sugar-scrub-15-oz-pineapple-maqui-berry-coconut",
        "sugar-scrub-15-oz-raw-coconut-mango",
      ],
    },
    3: {
      handles: [
        "the-rosemary-vinegar-hair-rinse-shampoo-alternative-rosemary-mint-6-fl-oz",
        "lemon-sugar-love-hand-wash-lemon-sugar-12-fl-oz",
        "green-tea-aloe-soother-body-wash-green-tea-aloe-30-fl-oz",
        "the-grow-pro-shampoo-passion-fruit-marula-16-fl-oz",
        "watermelon-mint-refresh-body-wash-watermelon-mint-30-fl-oz",
        "the-multi-miracle-leave-in-conditioner-heat-protectant-coconut-agave-6-fl-oz",
        "the-scalp-restore-shampoo-jojoba-aloe-16-fl-oz",
        "coconut-mango-glow-hand-wash-coconut-mango-12-fl-oz",
        "pineapple-maqui-berry-reviver-body-wash-pineapple-maqui-berry-30-fl-oz",
        "watermelon-mint-refresh-hand-wash-watermelon-mint-12-fl-oz",
        "the-moisture-smoothie-hair-mask-avocado-coconut-10-fl-oz",
        "the-grow-pro-conditioner-passion-fruit-marula-16-fl-oz",
        "the-moisture-smoothie-shampoo-coconut-agave-16-fl-oz",
        "the-moisture-smoothie-conditioner-coconut-agave-16-fl-oz",
        "pineapple-maqui-berry-reviver-hand-wash-pineapple-maqui-berry-12-fl-oz",
        "the-deep-cleanse-shampoo-charcoal-matcha-16-fl-oz",
        "the-mighty-curl-leave-in-conditioner-papaya-coconut-5-fl-oz",
        "the-strength-builder-2-in-1-shampoo-conditioner-tea-tree-coconut-16-fl-oz",
        "the-scalp-restore-conditioner-jojoba-aloe-16-fl-oz",
        "the-mighty-curl-conditioner-rosemary-cider-vinegar-16-fl-oz",
        "the-volume-revive-shampoo-strawberry-white-tea-16-fl-oz",
        "fur-kids-sensitive-coat-shampoo-conditioner-agave-oatmeal-16-fl-oz",
        "the-mighty-curl-shampoo-rosemary-cider-vinegar-16-fl-oz",
        "the-mighty-curl-hair-mask-papaya-coconut-10-fl-oz",
        "the-oil-remedy-shampoo-rosemary-mint-16-fl-oz",
        "fur-kids-shiny-coat-shampoo-conditioner-coconut-mango-16-fl-oz",
        "the-volume-revive-conditioner-strawberry-white-tea-16-fl-oz",
        "fur-kids-freshen-up-pet-wipes-apple-cream-60-ct",
        "the-wave-maker-shampoo-lychee-coconut-16-fl-oz",
        "the-oil-remedy-conditioner-rosemary-mint-16-fl-oz",
        "the-wave-maker-conditioner-lychee-coconut-16-fl-oz",
        "the-color-renew-shampoo-prickly-pear-amber-16-fl-oz",
        "the-color-renew-conditioner-prickly-pear-amber-16-fl-oz",
        "charcoal-bamboo-reset-body-wash-charcoal-bamboo-20-fl-oz",
        "lemon-citrus-energizer-body-wash-lemon-citrus-20-fl-oz",
        "coconut-mango-glow-body-wash-coconut-mango-20-fl-oz",
        "caramel-vanilla-delight-body-wash-caramel-vanilla-20-fl-oz",
        "vanilla-creamy-coconut-bliss-body-wash-vanilla-coconut-20-fl-oz",
        "eucalyptus-sandalwood-boost-body-wash-eucalyptus-sandalwood-20-fl-oz",
        "green-tea-aloe-soother-body-wash-green-tea-aloe-20-fl-oz",
        "cedarleaf-mint-recharge-body-wash-cedarleaf-mint-20-fl-oz",
        "pineapple-maqui-berry-reviver-body-wash-pineapple-maqui-berry-20-fl-oz",
        "watermelon-mint-refresh-body-wash-watermelon-mint-20-fl-oz",
        "the-scalp-restore-hair-scalp-mask-charcoal-mint-6-6-fl-oz",
      ],
    },
    4: {
      handles: [
        "eco-body-bar-green-tea-cucumber-aloe-vera-5-oz",
      ],
    },
  },
};

function raw15_findOffer(handle) {
  for (const [packQty, config] of Object.entries(RAW15_SETTINGS.packOffers)) {
    if (config.handles.includes(handle)) {
      return { packQty: parseInt(packQty, 10) };
    }
  }
  return null;
}

function raw15_money(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

function raw15_currentHandle() {
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productsIndex = pathParts.indexOf("products");
  return productsIndex !== -1 ? pathParts[productsIndex + 1] : "";
}

async function raw15_fetchProduct(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    console.error(`[${RAW15_SETTINGS.experimentId}] Failed to fetch product data:`, err);
    return null;
  }
}

function raw15_getSelectedVariant(shopifyProduct) {
  const urlVariantId = new URLSearchParams(window.location.search).get("variant");
  if (urlVariantId) {
    const match = shopifyProduct.variants.find(v => String(v.id) === urlVariantId);
    if (match) return match;
  }
  return shopifyProduct.variants.find(v => v.available) || shopifyProduct.variants[0];
}

function raw15_injectStyles() {
  if (document.getElementById("rs-pack-selector-styles")) return;

  document.head.insertAdjacentHTML("beforeend", `
    <style id="rs-pack-selector-styles">
      .rs-pack-selector {
        display: flex;
        gap: .75rem;
        margin-bottom: 1.75rem;
        max-width: 580px;
      }
      .rs-pack-card {
        flex: 1;
        text-align: left;
        cursor: pointer;
        border: 1px solid rgba(0,0,0,.15);
        border-radius: 6px;
        padding: 1rem;
        background: transparent;
        font: inherit;
        display: flex;
        flex-direction: column;
        gap: .15rem;
        position: relative;
      }
      .rs-pack-card.is-selected {
        border-color: currentColor;
        border-width: 2px;
      }
      .rs-pack-card__media {
        position: relative;
        width: 100%;
        height: 70px;
        margin-bottom: .2rem;
        overflow: hidden;
        --stack-spacing: 65px;
      }
      .rs-pack-card__image {
        width: 60px;
        height: 70px;
        object-fit: contain;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .rs-pack-card__image--stacked {
        transform: translate(calc(-50% + var(--step, 0) * var(--stack-spacing)), -50%);
      }
      @media (max-width: 1000px) {
        .rs-pack-card {
          padding: 1rem .5rem;
        }
        .rs-pack-card__media {
          height: 60px;
        }
        .rs-pack-card__image {
          width: 50px;
          height: 60px;
        }
      }
      .rs-pack-card__title {
        font-weight: 600;
        font-size: .9rem;
      }
      .rs-pack-card__price {
        font-size: .85rem;
      }
      .rs-pack-card__compare-at {
        opacity: .6;
        margin-left: .35rem;
      }
      .rs-pack-card__badge {
        position: absolute;
        top: -.6rem;
        right: .5rem;
        background: rgb(var(--dialog-background));
        color: rgb(var(--on-sale-badge-text));
        font-size: .65rem;
        text-transform: uppercase;
        letter-spacing: .02em;
        padding: .15rem .4rem;
        border-radius: 3px;
        z-index: 1;
      }
      .rs-pack-card__badge--shipping {
        top: auto;
        bottom: -.6rem;
        right: .5rem;
        background: #473729;
        color: #ffffff;
      }
      .rs-pack-active [data-block-type="quantity-selector"] {
        display: none;
      }
    </style>
  `);
}

function raw15_buildCardMedia(img_url, qty) {
  if (!img_url) return "";

  const stack_count = qty > 1 ? Math.min(qty, 6) : 1;
  const images = Array.from({ length: stack_count }, (_, i) => {
    if (stack_count === 1) {
      return `<img src="${img_url}" width="50" height="50" class="rs-pack-card__image" alt="" loading="lazy">`;
    }
    const step = i - (stack_count - 1) / 2;

    return `<img src="${img_url}" width="50" height="50" class="rs-pack-card__image rs-pack-card__image--stacked" style="--step:${step}" alt="" loading="lazy">`;
  }).join("");

  return `<div class="rs-pack-card__media">${images}</div>`;
}

function raw15_layoutStackedMedia(media_el) {
  const imgs = media_el.querySelectorAll(".rs-pack-card__image--stacked");
  if (imgs.length < 3) return;
  if (!window.matchMedia("(max-width: 1000px)").matches) {
    media_el.style.removeProperty("--stack-spacing");
    return;
  }

  const container_width = media_el.clientWidth;
  const image_width = imgs[0].getBoundingClientRect().width;
  const available = Math.max(0, container_width - image_width);
  const spacing = available / (imgs.length - 1);

  media_el.style.setProperty("--stack-spacing", `${spacing}px`);
}

function raw15_renderSelector(offer, unit_price_cents, img_url) {
  const pack_compare_at_cents = unit_price_cents * offer.packQty;
  // flat 10% off in every group, taken per unit then multiplied by the pack size
  const ten_percent_off_cents = (Math.ceil(unit_price_cents * 0.9) * offer.packQty);
  const ships_free_badge = RAW15_SETTINGS.freeShippingOnPacks && ten_percent_off_cents >= 3500
    ? `<span class="rs-pack-card__badge rs-pack-card__badge--shipping">Ships Free</span>`
    : "";

  return `
    <div class="rs-pack-selector" data-raw15-selector role="radiogroup" aria-label="Purchase option">
      <button type="button" class="rs-pack-card is-selected" data-raw15-option data-qty="1" data-total="${unit_price_cents}" role="radio" aria-checked="true">
        ${raw15_buildCardMedia(img_url, 1)}
        <span class="rs-pack-card__title">Single</span>
        <span class="rs-pack-card__price">${raw15_money(unit_price_cents)}</span>
      </button>
      <button type="button" class="rs-pack-card" data-raw15-option data-raw15-is-pack data-qty="${offer.packQty}" data-total="${ten_percent_off_cents}" role="radio" aria-checked="false">
        <span class="rs-pack-card__badge">Save 10%</span>
        ${ships_free_badge}
        ${raw15_buildCardMedia(img_url, offer.packQty)}
        <span class="rs-pack-card__title">${offer.packQty}-Pack</span>
        <span class="rs-pack-card__price">
          ${raw15_money(ten_percent_off_cents)}
          <s class="rs-pack-card__compare-at">${raw15_money(pack_compare_at_cents)}</s>
        </span>
      </button>
    </div>
  `;
}

function raw15_applySelection(product_info_el, option_el) {
  product_info_el.querySelectorAll("[data-raw15-option]").forEach(el => {
    const selected = el === option_el;
    el.classList.toggle("is-selected", selected);
    el.setAttribute("aria-checked", selected ? "true" : "false");
  });

  const qty = parseInt(option_el.getAttribute("data-qty"), 10) || 1;

  const qty_input = product_info_el.querySelector('input[is="quantity-input"]');
  if (qty_input) {
    qty_input.value = qty;
    qty_input.dispatchEvent(new Event("input", { bubbles: true }));
    qty_input.dispatchEvent(new Event("change", { bubbles: true }));
  } else {
    const form = product_info_el.querySelector('form[is="product-form"]');
    if (form) {
      let hidden = form.querySelector('input[name="quantity"][data-raw15-hidden-qty]');
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "quantity";
        hidden.setAttribute("data-raw15-hidden-qty", "");
        form.appendChild(hidden);
      }
      hidden.value = qty;
    }
  }
}

// -----------------------------------------------------------------------------
// ACTIVATION
// -----------------------------------------------------------------------------
window.activateRAW15 = async function activateRAW15() {

  proteus.add_cartAttribute("_proteus_discount_1", "[RAW-15] v1")

  if (window._raw15Active) {
    console.log(`[${RAW15_SETTINGS.experimentId}] Already activated. Skipping.`);
    return;
  }
  window._raw15Active = true;

  const currentHandle = raw15_currentHandle();
  const offer = raw15_findOffer(currentHandle);

  if (!offer) {
    console.log(`[${RAW15_SETTINGS.experimentId}] Handle "${currentHandle}" not in pilot list. Skipping.`);
    return;
  }

  const shopifyProduct = await raw15_fetchProduct(currentHandle);
  if (!shopifyProduct) {
    console.log(`[${RAW15_SETTINGS.experimentId}] Not a product page or fetch failed. Exiting.`);
    return;
  }

  const variant = raw15_getSelectedVariant(shopifyProduct);
  if (!variant) {
    console.log(`[${RAW15_SETTINGS.experimentId}] No variant found. Exiting.`);
    return;
  }

  window.sessionStorage.setItem(RAW15_SETTINGS.experimentId, RAW15_SETTINGS.version);

  const buy_buttons_el = await waitForElement(".product-info__buy-buttons");
  const product_info_el = buy_buttons_el.closest(".product-info");
  if (!product_info_el) {
    console.log(`[${RAW15_SETTINGS.experimentId}] No .product-info ancestor found. Exiting.`);
    return;
  }

  if (product_info_el.querySelector("[data-raw15-selector]")) {
    console.log(`[${RAW15_SETTINGS.experimentId}] Already injected. Skipping.`);
    return;
  }

  const img_url = (variant.featured_image && variant.featured_image.src) || shopifyProduct.featured_image || "";

  raw15_injectStyles();
  product_info_el.classList.add("rs-pack-active");
  buy_buttons_el.insertAdjacentHTML("beforebegin", raw15_renderSelector(offer, variant.price, img_url));

  product_info_el.querySelectorAll("[data-raw15-option]").forEach(option_el => {
    option_el.addEventListener("click", () => raw15_applySelection(product_info_el, option_el));
  });

  const raw15_layout_all_stacks = () => {
    product_info_el.querySelectorAll(".rs-pack-card__media").forEach(raw15_layoutStackedMedia);
  };
  raw15_layout_all_stacks();
  window.addEventListener("resize", debounce(raw15_layout_all_stacks, 150));

  window._raw15 = { handle: currentHandle, offer, variant };

  console.log(`[${RAW15_SETTINGS.experimentId}] Pack selector injected for handle "${currentHandle}" (${offer.packQty}-pack, 10% off ${raw15_money(variant.price)}/ea).`);
};

console.log("[RAW-15] Ready.");
// end [RAW-15]